import { fetchFileFactory } from "../../../utils/fetchFactory"

export const uploadFiles = async (formData: FormData) => fetchFileFactory('/api/documents/upload-files', {
    method: 'POST',
    body: formData
})